import { useAuth } from '@praxis/component-auth'
import { Navigate, NavigateFunction, useNavigate } from 'react-router'

export const Home = () => {
  const { isAuthenticated, isAuthorized } = useAuth()
  const navigate = useNavigate()

  return (
    <HomeComponent
      isAuthenticated={isAuthenticated()}
      isAuthorized={isAuthorized()}
      navigate={navigate}
    />
  )
}

type HomeComponentProps = {
  isAuthenticated: boolean
  isAuthorized: boolean
  navigate: NavigateFunction
}

export const HomeComponent = (props: HomeComponentProps) => {
  const { isAuthenticated, isAuthorized } = props

  if (!isAuthenticated) {
    // Redirect
    return <Navigate to={'/login'} replace={true} />
  } else if (!isAuthorized) {
    return (
      <div className="hc-ta-center">
        <p>Unauthorized: Please contact support to request access.</p>
      </div>
    )
  } else {
    // Authenticated, authorized
    return <Navigate to={'/dashboard'} replace={true} />
  }
}
